define('views/parts/form/datepicker',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/api',
    'services/i18n',
    // templates
    'text!templates/parts/form/datepicker.html',
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    API,
    i18n,
    // templates
    TDatePicker
) {

    /**
     * Input box with calendar date picker.
     *
     * ```
     * new VDatePicker({ label: 'Date', attribute: '_date', labelposition: "top", model: this.model, })
     * ```
     *
     * @param {Boolean} calendar  if it should trigger the datepicker itself.
     * @param {Object}  datepicker  options to pass to datepicker init.
     * @param {string}  attribute  of the model to use.
     *
     * FORMAT
     * 	d, dd: Numeric date, no leading zero and leading zero, respectively. Eg, 5, 05.
     *  D, DD: Abbreviated and full weekday names, respectively. Eg, Mon, Monday.
     *  m, mm: Numeric month, no leading zero and leading zero, respectively. Eg, 7, 07.
     *  M, MM: Abbreviated and full month names, respectively. Eg, Jan, January
     *  yy, yyyy: 2- and 4-digit years, respectively. Eg, 12, 2012.
     *
     */
    var VDatePicker = Backbone.View.extend({
        template: TDatePicker,
        events: {
            "click .datepicker-toggle": "toggleCalendar",
            "changeDate": "onChangeDate",
            'focus input': 'onInputFocus',
            'blur input': 'onInputBlur',
            'clearDate': 'onClearDate',
        },
        regions: {
            root: ".input-placeholder",
            input: ".datepicker-part .form-control",
            part: ".datepicker-part",
            label: ".control-label",
        },
        initialize: function(opt) {
            // default options
            var options = this.options = _.extend({
                //multidate: true,
                label: "Date",
                attribute: "date",
                labelposition: "top",
                id: this.cid,
                inline: false,
                responsive: false,
                calendar: true,
                validation: false,
                validationMsg: true,
                needsTranslatedLabel: true,
                format: API.format.date,
                utc: false, // UTC by default (Set to false after Bug in FRANCE)
                today: false, // default to today
            }, opt);

            // default datepicker options
            options.datepicker = _.extend({
                multidate: options.multidate === true ? true : false,
                autoclose: true,
                todayHighlight: true,
                format: "yyyy/mm/dd",
                language: i18n.language ? i18n.language.substring(0, 2) : 'en'
            }, options.datepicker);

            if (!this.model) {
                this.model = new Backbone.Model();
                if (this.options.datepicker.multidate === false) {
                    this.updateDate();
                }
            }

        },
        render: function() {
            this.$el.empty().append(
                Mustache.render(this.template,
                    Mustache.getContext(this.options)));

            this.generateZones();

            _.defer(this.renderCalendar.bind(this));

            this.getElem().on('hide', function(e) {
                e.stopPropagation();
            });

            return this;
        },

        renderCalendar: function() {
            if (this.options.calendar) {
                this.getElem().datepicker(_.extend({}, this.options.datepicker, {
                    container: this.zone.$root
                }));
                if (this.options.datepicker.multidate === false)
                    this.setDate(this.getValue());
                //this.getElem().datepicker('setMultidate', true);
            }
        },

        getElem: function() {
            return _.result(this.options, "inline") ?
                this.zone.$part :
                this.zone.$input;
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        getMultiValue: function() {
            return this.dates;
        },

        toggleCalendar: function() {
            this.getElem().datepicker('show');
        },

        setDate: function(date) {
            if (date)
                this.getElem().datepicker("setDate", API.formatDate(date));
        },

        setMultiDate: function(dates) {
            var dtArr = new Array(API.formatDate(dates[0]));
            var alldates = [];
            // // pushing first date
            // alldates.push(new Date(2018, 1, 5));
            // var elem = this.getElem();
            // console.log(elem.DateRangePicker);
            this.getElem().datepicker('destroy');
            this.getElem().datepicker(this.options.datepicker);
            this.getElem().datepicker("setDates", dtArr); //[new Date(2018, 1, 5), new Date(2018, 1, 8)]);
            //this.getElem().datepicker("setDates", new Date(2015, 1, 1));
            //this.getElem().datepicker('destroy');

            //

            // if (this.options.calendar) {
            //     this.getElem().datepicker(_.extend({}, this.options.datepicker, {
            //         container: this.zone.$root
            //     }));
            // }
        },

        clearDate: function() {
            this.getElem().datepicker("update", '');
        },

        updateDate: function(date) {
            var opt = this.options;
            date = date || (opt.today ? moment() : void 0);

            if (date) {
                date = opt.utc ? moment(date).utc() : moment(date);
                this.model.set(opt.attribute, date.format(opt.format));
            } else {
                this.model.set(opt.attribute, null);
            }
        },
        ////////////
        // events //
        ////////////
        onChangeDate: function(e) {
          //Multidate handling
          if (this.options.datepicker.multidate === false) {
              this.updateDate(e.date);
          } else {
              this.dates = e.dates;
          }
        },

        onInputFocus: function() {
            this.zone.$label.addClass("focus");
        },
        onInputBlur: function(e) {
            if (e.target.value) {
                this.model.set(this.options.attribute, moment(e.target.value).format());
            }

            this.zone.$label.removeClass("focus");
        },
        onClearDate: function() {
            this.updateDate(null);
        }

    });

    return VDatePicker;

});

